<div class="quick-view-button-container">
  <button
    #button
    [ngClass]="_classes"
    (click)="onClickIcon()"
    [class.quick-view-button-selected]="selected"
    [class.quick-view-button-deselected]="!selected"
  >
    <ng-content />
  </button>
  <span
    class="material-symbols-outlined quickview-icon"
    [class.quick-view-selected]="selected"
    [class.quick-view-deselected]="!selected"
  >
    {{ selected ? 'close' : 'north_east' }}
  </span>
</div>
